export default {
  UserPinAdded: new Event('map-user-pin-added'),

  MapLoaded(map) {
    return new CustomEvent('map-loaded', {
      detail: map,
    });
  },

  MarkerClicked(marker) {
    return new CustomEvent('marker-clicked', {
      detail: marker,
    });
  },
};
